import { useState } from "react";
import { toast } from "sonner";
import { Mail, Loader2, BellRing } from "lucide-react";
import { subscribeNewsletter, formatApiError } from "@/lib/api";

export const NewsletterSignup = ({ country = "" }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) return toast.error("Entrez un email valide.");
    setLoading(true);
    try {
      const res = await subscribeNewsletter(email, country);
      toast.success(res.message || "Inscription confirmée !");
      setDone(true); setEmail("");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div className="rounded-2xl border border-gold/25 bg-gradient-to-r from-navy/70 to-night p-7 sm:p-9" data-testid="newsletter-signup">
      <div className="flex flex-col sm:flex-row sm:items-center gap-6 justify-between">
        <div className="max-w-xl">
          <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-gold"><BellRing size={14} /> Alerte veille hebdomadaire</span>
          <h3 className="mt-3 font-display text-2xl text-white">Recevez chaque semaine la <em className="not-italic italic text-gold-gradient">veille stratégique</em></h3>
          <p className="mt-2 text-sm text-white/60 font-body">Économie, fiscalité, marchés publics, BCEAO & BAD — Bénin & Côte d'Ivoire, directement dans votre boîte mail.</p>
        </div>
        <form onSubmit={submit} className="w-full sm:w-auto shrink-0">
          <div className="flex items-center gap-2 rounded-full border-2 border-gold bg-white/10 backdrop-blur-md pl-4 pr-2 py-2 min-w-[300px]">
            <Mail size={17} className="text-gold-light shrink-0" />
            <input
              type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder="votre@email.com" data-testid="newsletter-email"
              className="flex-1 bg-transparent outline-none text-sm text-white placeholder:text-white/50 font-body"
            />
            <button type="submit" disabled={loading} data-testid="newsletter-submit"
              className="inline-flex items-center gap-1.5 rounded-full bg-gradient-to-r from-gold to-gold-light px-4 py-2 text-sm font-semibold text-navy disabled:opacity-60">
              {loading ? <Loader2 size={15} className="animate-spin" /> : (done ? "Inscrit ✓" : "S'inscrire")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
